<template>
  <div class="message-container">
    <h4 v-bind:class="type" class="message">{{ text }}</h4>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      text: null,
      type: null,
      timeoutHandle: null
    }
  },
  computed: {
    ...mapGetters(['message'])
  },
  watch: {
    message(val, oldVal) {
      this.text = val.text
      this.type = val.type

      clearTimeout(this.timeoutHandle)
      this.timeoutHandle = setTimeout(() => {
        this.text = null
        this.type = null
      }, 10000)
    }
  }
}
</script>

<style scoped>
.message-container {
  position: fixed;
  bottom:10px;
  left: 30%;
  z-index: 999;
  text-align: center;
  min-width: 300px;
  margin: 0 auto;
}
.message {
  display: inline-block;
  margin-top: 5px;
  font-weight: bold;
}
.success.message {
  color: green;
}
.error.message {
  color: red;
}
h4 {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/MessageContainer.vue